import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { toCurrency } from 'utilities/format';
import Typography from '@material-ui/core/Typography';

const PropertyUWAVM = ({ containerClass, classes, selectedContainer }) => {
  if (!selectedContainer) return null;

  const { normalAvm, normalAvmQuartileOne, normalAvmQuartileThree, normalAvm90thPctileValue, normalAvm95thPctileValue, sqft } = selectedContainer;

  const renderValueText = value =>
    value ? (
      <>
        <Typography variant="body2" display='inline'>
          {toCurrency(value, 0)}
        </Typography>
        {/**dummy grid fill */}
        <div />
        <Typography className={classes.smallerFont} display='inline'>
          {toCurrency(value / sqft, 0)}/sqft
        </Typography>
      </>
    ) : (
        <Typography variant="body2">N/A</Typography>
      );

  const renderRow = (label, value) => (
    <div className={classes.rowContainer}>
      <Typography variant="body2" className={classes.smallerFont}>
        {label}
      </Typography>
      {renderValueText(value)}
    </div>
  );
  return (
    <div className={containerClass}>
      <div className={classes.gridContainer}>
        {renderRow('AVM Normal', normalAvm)}
        {renderRow('AVM Normal Q1', normalAvmQuartileOne)}
        {renderRow('AVM Normal Q3', normalAvmQuartileThree)}
        {renderRow('AVM Normal 90th Percentile', normalAvm90thPctileValue)}
        {renderRow('AVM Normal 95th Percentile', normalAvm95thPctileValue)}
      </div>
    </div>
  );
};

const styles = theme => ({
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gridTemplateRows: 'auto auto auto auto auto',
    gridAutoFlow: 'column'
  },
  rowContainer: {
    display: 'grid',
    gridTemplateColumns: '60% 40%',
    padding: '5px 0'
  },
  smallerFont: {
    fontSize: '0.8rem',
    color: 'gray'
  }
});

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = dispatch => ({});

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(PropertyUWAVM);
